import { NewsCategorySideInput } from "../../components"
import Pen from "../../assets/icon/NewsIcons/MainAdmin/NewsPenSmallWhite"

const MainAdminNewsCategoryEdit = () => {
    return(
        <div className="rounded-[15px] pt-[15px] px-[15px] pb-[120px] border-borderGray border-2">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2">ویرایش دسته بندی</p>
            <div className="my-[22px]"><NewsCategorySideInput/></div>
            <div className="flex justify-center items-center">
            <button className="w-[170px] h-[40px] bg-mainGreen shadow-norm-shadow rounded-[10px] mt-2 flex justify-center items-center ">
                <div className="mt-[2px]"><Pen/></div>
                <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">ویرایش دسته بندی</p>
            </button>
            </div>
        </div>
    )
}

export default MainAdminNewsCategoryEdit;